import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './StronaGlowna.css'

/**
 * Nowa strona główna (wariant D z makiety 2026-10-28; repo VV `07_STAN_I_ROADMAPA.md`, wiersz „Nowa strona
 * główna”, decyzja o pasku w `05_ZASADY_I_DECYZJE.md`). Jeden cel na start: brama „dla domu / dla firm”,
 * pod nią trzy drogi albo skrót platformy dla firm, na dole wyszukiwarka modeli.
 *
 * Górny pasek nawigacji zostaje obecny (decyzja właściciela), ta strona to tylko treść pod nim.
 * Tylko wersja polska: Rynek, `/dla-firm` i ankieta firm istnieją wyłącznie w Polsce (Home.jsx wybiera stronę).
 */

const REJESTRACJA_FIRMY = '/rejestracja?konto=firma'
const obraz = (nazwa) => `${process.env.PUBLIC_URL || ''}/img/dla-firm/${nazwa}.webp`

// Kategorie wyszukiwarki i katalogu; trasy muszą pokrywać się z listingami (jak KATEGORIE_SZUKANIA w HeroAssistant.jsx).
// `krotka` to nazwa w liście „Szukaj w” w polu, `katalog` to nazwa kafelka prowadzącego do listingu.
const KATEGORIE = [
  { key: 'panele', nazwa: 'Moduły', krotka: 'Moduły', katalog: 'Moduły PV', licznik: '600+ modeli', route: '/panele', podpowiedz: 'Marka albo model modułu' },
  { key: 'inwertery', nazwa: 'Falowniki', krotka: 'Falowniki', katalog: 'Falowniki', licznik: '1300+ modeli', route: '/inwertery', podpowiedz: 'Marka albo model falownika' },
  { key: 'magazyny', nazwa: 'Magazyny energii', krotka: 'Magazyny', katalog: 'Magazyny energii', licznik: '700+ modeli', route: '/magazyny', podpowiedz: 'Marka albo model magazynu' },
  { key: 'ladowarki', nazwa: 'Ładowarki EV', krotka: 'Ładowarki', katalog: 'Ładowarki EV', licznik: '100+ modeli', route: '/ladowarki', podpowiedz: 'Marka albo model ładowarki' },
]

// Kolory numerów idą płynnie od niebieskiego przez błękit do zieleni (uwaga właściciela 2026-10-28),
// jak droga od doboru do dotacji; wcześniej pomarańcz i żółć wyglądały na ostrzeżenia.
const KROKI = [
  { nr: '01', nazwa: 'Dobór sprzętu', to: '/dobor-zestawu-pv', kolor: { background: '#DBEAFE', color: '#1E40AF' } },
  { nr: '02', nazwa: 'Projekt 3D', to: '/projekt-3d', kolor: { background: '#E0EFFF', color: '#1D4ED8' } },
  { nr: '03', nazwa: 'Oferta PDF', to: '/dla-firm#sprzedaz', kolor: { background: '#E0F2FE', color: '#0369A1' } },
  { nr: '04', nazwa: 'Zamówienia i montaże', to: '/dla-firm#realizacja', kolor: { background: '#CFFAFE', color: '#0E7490' } },
  { nr: '05', nazwa: 'Dokumenty OSD i PSP', to: '/zgloszenie-mikroinstalacji', kolor: { background: '#CCFBF1', color: '#0F766E' } },
  { nr: '06', nazwa: 'Dotacja PME2', to: '/teczka-pme2', kolor: { background: '#D1FAE5', color: '#047857' } },
]

// 15 wykonawców z okolicy: 3 wygrywają, 3 odmawiają, reszta składa ofertę (kolejność stała, żeby animacja była powtarzalna).
const WYGRANI = [2, 8, 11]
const ODMOWY = [4, 9, 13]
const KROPKI = Array.from({ length: 15 }, (_, i) => ({
  klasa: WYGRANI.includes(i) ? 'sg-kr-wygrana' : ODMOWY.includes(i) ? 'sg-kr-odmowa' : 'sg-kr-oferta',
  opoznienie: `${(i * 0.04).toFixed(2)}s, 0s`,
}))

// 40 wierszy cennika; taśma zatrzymuje się na wierszach 33, 31 i 35 (różne ceny w każdej rundzie).
const WIERSZE = Array.from({ length: 40 }, (_, i) => ({
  cena: `${String(4500 + ((i * 397) % 1700)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} zł`,
  szer: `${40 + ((i * 37) % 45)}%`,
}))

const IkonaModul = (p) => (
  <svg viewBox="0 0 20 14" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" {...p}><rect x="1" y="1" width="18" height="12" rx="1.5" /><path d="M7 1v12M13 1v12M1 7h18" strokeWidth="1" /></svg>
)
const IkonaFalownik = (p) => (
  <svg viewBox="0 0 14 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true" {...p}><rect x="1" y="1" width="12" height="14" rx="2.5" /><path d="M3.6 9c.9-2.2 2.1-2.2 3 0s2.1 2.2 3 0" strokeWidth="1.3" /></svg>
)
const IkonaMagazyn = (p) => (
  <svg viewBox="0 0 20 12" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" {...p}><rect x="1" y="1" width="16" height="10" rx="2.5" /><path d="M18.5 4.5v3" strokeWidth="2" strokeLinecap="round" /><rect x="3" y="3" width="6" height="6" rx="1" fill="currentColor" stroke="none" /></svg>
)
const IkonaLadowarka = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...p}><rect x="5" y="3" width="10" height="18" rx="2" /><path d="M15 8h2a2 2 0 0 1 2 2v5a2 2 0 0 0 4 0V7" /><path d="m10.5 8-2 4h3l-2 4" /></svg>
)
const IKONY_KATEGORII = {
  panele: <IkonaModul width="24" height="17" strokeWidth="1.6" />,
  inwertery: <IkonaFalownik width="17" height="20" strokeWidth="1.6" />,
  magazyny: <IkonaMagazyn width="24" height="15" strokeWidth="1.6" />,
  ladowarki: <IkonaLadowarka width="18" height="20" />,
}
const Strzalka = ({ rozmiar = 16 }) => (
  <svg width={rozmiar} height={rozmiar} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
)
const Ptaszek = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m5 12 4.5 4.5L19 7" /></svg>
)

/* Kartka oferty z lupą (ta sama grafika co GrafikaOferta.jsx, tu z ruchem lupy). */
const KartkaOferty = () => (
  <g id="sgKartkaOf">
    <rect x="18" y="6" width="196" height="136" rx="14" fill="#FFFFFF" />
    <rect x="32" y="20" width="24" height="24" rx="7" fill="#FEF3C7" /><circle cx="44" cy="32" r="4" fill="#F59E0B" />
    <path d="M44 23.5v2M44 38.5v2M35.5 32h2M50.5 32h2M38 26l1.4 1.4M48.6 36.6l1.4 1.4M38 38l1.4-1.4M48.6 27.4l1.4-1.4" stroke="#F59E0B" strokeWidth="1.6" strokeLinecap="round" />
    <rect x="64" y="23" width="72" height="7" rx="3.5" fill="#1E3A8A" opacity="0.9" /><rect x="64" y="35" width="46" height="5" rx="2.5" fill="#CBD5E1" />
    <line x1="32" y1="52" x2="200" y2="52" stroke="#EEF2F7" strokeWidth="1.5" />
    <circle cx="38" cy="64" r="7" fill="#D1FAE5" /><path d="M34.8 64.2l2.2 2.2 4.4-4.8" fill="none" stroke="#059669" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="52.5" y="59" width="15" height="10" rx="1.5" fill="#DBEAFE" stroke="#2563EB" strokeWidth="1.3" /><path d="M57.5 59v10M62.5 59v10M52.5 64h15" stroke="#2563EB" strokeWidth="0.9" />
    <rect x="74" y="61" width="78" height="6" rx="3" fill="#E2E8F0" /><rect x="172" y="61" width="28" height="6" rx="3" fill="#CBD5E1" />
    <circle cx="38" cy="80" r="7" fill="#D1FAE5" /><path d="M34.8 80.2l2.2 2.2 4.4-4.8" fill="none" stroke="#059669" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="54" y="73" width="12" height="14" rx="2.5" fill="#DBEAFE" stroke="#2563EB" strokeWidth="1.3" /><path d="M56.6 80.5c0.9-2.2 2.1-2.2 3 0s2.1 2.2 3 0" fill="none" stroke="#2563EB" strokeWidth="1.2" strokeLinecap="round" /><circle cx="63.4" cy="76" r="0.9" fill="#10B981" />
    <rect x="74" y="77" width="60" height="6" rx="3" fill="#E2E8F0" /><rect x="172" y="77" width="28" height="6" rx="3" fill="#CBD5E1" />
    <circle cx="38" cy="96" r="7" fill="#FEE2E2" /><path d="M35.6 91.6v9" stroke="#DC2626" strokeWidth="1.6" strokeLinecap="round" /><path d="M35.6 92.1h6.4l-1.8 2.4 1.8 2.4h-6.4z" fill="#DC2626" />
    <rect x="52.5" y="91.5" width="13" height="9" rx="2" fill="#DBEAFE" stroke="#2563EB" strokeWidth="1.3" /><rect x="65.9" y="94.2" width="1.9" height="3.6" rx="0.8" fill="#2563EB" /><rect x="54.5" y="93.5" width="5.5" height="5" rx="1" fill="#2563EB" />
    <rect x="74" y="93" width="86" height="6" rx="3" fill="#E2E8F0" /><rect x="172" y="93" width="28" height="6" rx="3" fill="#CBD5E1" />
    <rect x="32" y="110" width="40" height="4" rx="2" fill="#CBD5E1" /><rect x="32" y="120" width="150" height="8" rx="4" fill="#E2E8F0" /><rect x="78" y="120" width="62" height="8" rx="4" fill="#6EE7B7" />
    <circle cx="118" cy="124" r="6" fill="#2563EB" stroke="#FFFFFF" strokeWidth="2.5" />
    <g transform="rotate(-8 196 29)"><path d="M178 19h39a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5h-39l-8-10z" fill="#FBBF24" /><circle cx="177.5" cy="29" r="2" fill="#FFFFFF" /><text x="200" y="33" textAnchor="middle" fontSize="11" fontWeight="800" fill="#78350F">zł</text></g>
    <circle cx="206" cy="126" r="17" fill="#10B981" stroke="#FFFFFF" strokeWidth="4" /><path d="M198.5 126.5l5 5 9.5-10" fill="none" stroke="#FFFFFF" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
  </g>
)

function KartyDlaDomu() {
  return (
    <div className="sg-karty">
      <Link to="/rynek" className="sg-karta sg-karta-glowna">
        <div className="sg-ilustracja sg-il-zlecenie" aria-hidden="true">
          <div className="sg-il-rzad">
            <div className="sg-zlec">
              <span className="sg-fala" /><span className="sg-fala sg-fala2" />
              <svg width="30" height="30" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M6 14.5V28h20V14.5" stroke="#0F172A" strokeWidth="2" strokeLinejoin="round" /><path d="M14 28v-7h4v7" stroke="#0F172A" strokeWidth="1.6" strokeLinejoin="round" /><path d="M17.4 7.6 24.9 13.9 23.3 15.8 15.8 9.5z" fill="#2563EB" /><path d="M19.3 9.2 17.7 11.1M21.2 10.8 19.6 12.7M23 12.4 21.4 14.3M16.6 8.6 24.1 14.9" stroke="#BFDBFE" strokeWidth="0.6" /><path d="M3 15.5 16 4.5l13 11" stroke="#0F172A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
              <span className="sg-zlec-podpis">Zlecenie</span>
            </div>
            <div className="sg-kropki">
              {KROPKI.map((k, i) => <span key={i} className={`sg-kr ${k.klasa}`} style={{ animationDelay: k.opoznienie }} />)}
            </div>
          </div>
          <div className="sg-napisy">
            <span className="sg-et sg-et1">Zlecenie trafia do 15 wykonawców z okolicy</span>
            <span className="sg-et sg-et2">12 z nich składa oferty w 48 godzin</span>
            <span className="sg-et sg-et3">Kontakt przekazujesz tylko wybranym</span>
          </div>
        </div>
        <span className="sg-etykieta">Szukam wykonawcy</span>
        <span className="sg-karta-tytul">Zbierz oferty od wykonawców z okolicy</span>
        <span className="sg-karta-opis">Odpowiedz na kilka pytań lub łatwo zaprojektuj instalację w 3D. Stwórz konkurs ofert i nikt nie dzwoni bez Twojej zgody.</span>
        <span className="sg-przycisk sg-przycisk-pelny">Wystaw zlecenie</span>
      </Link>

      <Link to="/dobierz-zestaw" className="sg-karta">
        <div className="sg-ilustracja sg-il-ceny" aria-hidden="true">
          <div className="sg-cennik">
            <div className="sg-ikony">
              <span className="sg-ik sg-ik1"><IkonaModul width="20" height="14" />Moduły</span>
              <span className="sg-ik sg-ik2"><IkonaFalownik width="14" height="16" />Falownik</span>
              <span className="sg-ik sg-ik3"><IkonaMagazyn width="20" height="12" />Magazyn</span>
            </div>
            <div className="sg-okno-cen">
              <div className="sg-tasma">
                {WIERSZE.map((w, i) => <span key={i} className="sg-wiersz"><i style={{ width: w.szer }} /><b>{w.cena}</b></span>)}
              </div>
              <span className="sg-wybor" />
            </div>
          </div>
          <div className="sg-zestaw">
            <span className="sg-wezel sg-dob1"><IkonaModul width="22" height="15" strokeWidth="1.6" /></span>
            <span className="sg-lin"><span className="sg-prad" /></span>
            <span className="sg-wezel sg-dob2"><IkonaFalownik width="15" height="18" strokeWidth="1.6" /></span>
            <span className="sg-lin"><span className="sg-prad sg-prad-gora" /></span>
            <span className="sg-wezel sg-dob3"><IkonaMagazyn width="22" height="14" strokeWidth="1.6" /></span>
          </div>
        </div>
        <span className="sg-etykieta">Wybieram sprzęt</span>
        <span className="sg-karta-tytul">Porównaj ceny i dobierz zestaw</span>
        <span className="sg-karta-opis">Skanujemy oferty i składamy zgodny zestaw: moduły, falownik i magazyn.</span>
        <span className="sg-przycisk">Dobierz zestaw</span>
      </Link>

      <Link to="/sprawdz-oferte" className="sg-karta">
        <div className="sg-ilustracja sg-il-oferta" aria-hidden="true">
          <svg viewBox="0 0 240 150" width="260" height="162" aria-hidden="true">
            <defs>
              <clipPath id="sgSoczewka"><circle r="16" /></clipPath>
              <KartkaOferty />
            </defs>
            <use href="#sgKartkaOf" />
            <g className="sg-lupa">
              <circle cx="3" cy="4" r="17" fill="#0F172A" opacity="0.14" />
              <g clipPath="url(#sgSoczewka)"><rect x="-16" y="-16" width="32" height="32" fill="#FFFFFF" /><g className="sg-lupa-obraz"><use href="#sgKartkaOf" /></g></g>
              <circle r="16" fill="#BFDBFE" opacity="0.14" />
              <path d="M-10.5-5.5a11.5 11.5 0 0 1 5.5-5.5" fill="none" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" opacity="0.85" />
              <circle r="16" fill="none" stroke="#1E3A8A" strokeWidth="3.5" />
              <path d="M12 12L24 24" stroke="#1E3A8A" strokeWidth="6.5" strokeLinecap="round" />
            </g>
          </svg>
        </div>
        <span className="sg-etykieta">Mam ofertę</span>
        <span className="sg-karta-tytul">Sprawdź ofertę od instalatora</span>
        <span className="sg-karta-opis">Wgraj PDF, zdjęcie lub opisz ofertę. Wyłapiemy zawyżoną cenę, niezgodny sprzęt i błędy w dotacji.</span>
        <span className="sg-przycisk">Sprawdź ofertę</span>
      </Link>
    </div>
  )
}

function DlaFirm() {
  return (
    <>
      <div className="sg-firma-hero">
        <div className="sg-firma-tekst">
          <span className="sg-plakietka">Sprzedaż i realizacja instalacji</span>
          <h2 className="sg-h2">Branża przyspiesza. <span>Nie zostań w tyle.</span></h2>
          <p className="sg-akapit">Asystent VoltValue dobierze sprzęt, zaprojektuje instalację w 3D i policzy koszty, a potem poprowadzi Cię od zamówienia po wniosek o dotację.</p>
          <ul className="sg-zalety">
            <li><Ptaszek />Bez karty płatniczej</li>
            <li><Ptaszek />Dedykowany CRM</li>
            <li><Ptaszek />Konta firmowe</li>
            <li><Ptaszek />Generator wniosków OSD, PSP, PME2</li>
          </ul>
          <div className="sg-cta">
            <Link to={REJESTRACJA_FIRMY} className="sg-cta-pelny">Zarejestruj się za darmo</Link>
            <Link to="/dla-firm" className="sg-cta-obrys">Zobacz wszystko dla firm</Link>
          </div>
        </div>

        <div className="sg-kompozycja">
          <div className="sg-okno sg-okno-projekt">
            <div className="sg-adres">voltvalue.pl/projekt-3d</div>
            <img src={obraz('hero-projekt-3d')} alt="Projekt 3D: model domu z modułami i panel ustawień" />
          </div>
          <div className="sg-okno sg-okno-dobor">
            <div className="sg-adres">voltvalue.pl/asystent-doboru</div>
            <img src={obraz('hero-dobor')} alt="Dobór sprzętu: najtańszy zgodny zestaw" />
          </div>
          <div className="sg-okno sg-okno-pulpit">
            <div className="sg-adres">voltvalue.pl/pulpit</div>
            <img src={obraz('hero-pulpit')} alt="Pulpit firmy: najbliższe 7 dni i sprzedaż w toku" />
          </div>
          <span className="sg-znacznik" style={{ left: '16%', top: '-10px' }}><span>1</span>Dobór sprzętu</span>
          <span className="sg-znacznik" style={{ right: '2%', top: '-4px' }}><span>2</span>Projekt 3D</span>
          <span className="sg-znacznik" style={{ left: '3%', bottom: '8px' }}><span>3</span>Montaże i zespół</span>
        </div>

        <div className="sg-talia-blok" aria-hidden="true">
          <div className="sg-zakladki">
            <span className="sg-zakl sg-zakl1"><span className="sg-pasek"><i /></span>Dobór sprzętu</span>
            <span className="sg-zakl sg-zakl2"><span className="sg-pasek"><i /></span>Projekt 3D</span>
            <span className="sg-zakl sg-zakl3"><span className="sg-pasek"><i /></span>Montaże</span>
          </div>
          <div className="sg-talia">
            <div className="sg-karta-t sg-kt1"><div className="sg-adres">voltvalue.pl/asystent-doboru</div><img src={obraz('hero-dobor')} alt="" /></div>
            <div className="sg-karta-t sg-kt2"><div className="sg-adres">voltvalue.pl/projekt-3d</div><img src={obraz('hero-projekt-3d')} alt="" /></div>
            <div className="sg-karta-t sg-kt3"><div className="sg-adres">voltvalue.pl/pulpit</div><img src={obraz('hero-pulpit')} alt="" /></div>
          </div>
        </div>
      </div>

      <div className="sg-kroki">
        <div className="sg-kroki-siatka">
          {KROKI.map((k, i) => (
            <Link key={k.nr} to={k.to} className="sg-krok" style={{ animationDelay: `${i}s` }}>
              <span className="sg-krok-nr" style={k.kolor}>{k.nr}</span>
              <span className="sg-krok-nazwa">{k.nazwa}</span>
            </Link>
          ))}
        </div>
        <div className="sg-tor" aria-hidden="true"><span className="sg-waz" /></div>
      </div>

      <div className="sg-rynek">
        <div className="sg-rynek-tekst">
          <span className="sg-rynek-plakietka"><span className="sg-live" />Rynek zleceń</span>
          <h3 className="sg-h3">Klienci z Twojej okolicy sami szukają wykonawcy</h3>
          <p className="sg-rynek-akapit">Uzupełnij ankietę firmy, a dostaniesz zlecenia najlepiej dopasowane do Twojej okolicy, zakresu prac i sprzętu. Ofertę składasz w 48 godzin, a z każdym zleceniem dostajesz gotową teczkę.</p>
          <Link to="/firma/ankieta" className="sg-rynek-cta">Uzupełnij ankietę firmy<Strzalka /></Link>
        </div>
        <div className="sg-stos" aria-hidden="true">
          <div className="sg-zlecenie sg-zlecenie-tyl">
            <span className="sg-zlecenie-gora"><span>Łęczyca</span><span>12 h</span></span>
            <span className="sg-zlecenie-tytul">10 kWp · magazyn 15 kWh</span>
          </div>
          <div className="sg-zlecenie sg-zlecenie-srodek">
            <span className="sg-zlecenie-gora"><span>Zgierz</span><span>31 h</span></span>
            <span className="sg-zlecenie-tytul">6,2 kWp · bez magazynu</span>
          </div>
          <div className="sg-zlecenie sg-zlecenie-przod">
            <span className="sg-zlecenie-gora"><span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}><span className="sg-live" />Pasuje do profilu Twojej firmy</span><span className="sg-termin">48 h</span></span>
            <span className="sg-zlecenie-tytul">Ozorków · 8,7 kWp</span>
            <span className="sg-zlecenie-opis">Magazyn 10 kWh · 40 000 do 47 000 zł</span>
            {/* Teczka zlecenia (Projekt 3D klienta): firma dostaje rysunki montażowe, model 3D i konkretny sprzęt. */}
            <div className="sg-teczka">
              <span className="sg-teczka-tytul sg-tecz-el">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></svg>
                Teczka zlecenia
              </span>
              <span className="sg-teczka-pliki">
                <span className="sg-plik sg-tecz-el" style={{ animationDelay: '.4s' }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" aria-hidden="true"><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4" /></svg>
                  Rysunki montażowe
                </span>
                <span className="sg-plik sg-tecz-el" style={{ animationDelay: '.8s' }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" aria-hidden="true"><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9z" /><path d="M4 7.5 12 12l8-4.5M12 12v9" /></svg>
                  Model 3D
                </span>
              </span>
              <span className="sg-sprzet sg-tecz-el" style={{ animationDelay: '1.2s' }}><IkonaModul width="14" height="10" />Jinko Tiger Neo 435 W × 20</span>
              <span className="sg-sprzet sg-tecz-el" style={{ animationDelay: '1.5s' }}><IkonaFalownik width="10" height="12" />Deye SUN-8K, trójfazowy hybrydowy</span>
              <span className="sg-sprzet sg-tecz-el" style={{ animationDelay: '1.8s' }}><IkonaMagazyn width="14" height="9" />Dyness, 10 kWh</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

function Wyszukiwarka() {
  const navigate = useNavigate()
  const [kategoria, setKategoria] = useState(KATEGORIE[0].key)
  const [fraza, setFraza] = useState('')
  const kat = KATEGORIE.find((k) => k.key === kategoria)

  const szukaj = (e) => {
    e.preventDefault()
    const q = fraza.trim()
    navigate(q ? `${kat.route}?search=${encodeURIComponent(q)}&page=1` : kat.route)
  }

  return (
    <section className="sg-szukaj" aria-labelledby="sg-szukaj-tytul">
      <div className="sg-szukaj-wnetrze">
        <div className="sg-szukaj-naglowek">
          <span className="sg-licznik">2700+ modeli</span>
          <h2 id="sg-szukaj-tytul" className="sg-szukaj-tytul">Szukasz konkretnego? Wpisz model albo markę i moc.</h2>
        </div>
        {/* Pole ma być widoczne na pierwszym ekranie (2026-10-28). Zakres szukania wybiera się w samym polu,
            bo duże kafelki kategorii wyglądały jak wejścia do katalogu, a tylko zmieniały zakres (2026-10-29). */}
        <form className="sg-pole" onSubmit={szukaj} role="search">
          <label className="sg-zakres">
            <span className="sg-ukryte">Szukaj w</span>
            <select value={kategoria} onChange={(e) => setKategoria(e.target.value)}>
              {KATEGORIE.map((k) => <option key={k.key} value={k.key}>{k.krotka}</option>)}
            </select>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
          </label>
          <svg className="sg-lupa-pola" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
          <input type="search" value={fraza} onChange={(e) => setFraza(e.target.value)} placeholder={kat.podpowiedz} aria-label={`Szukaj: ${kat.nazwa}`} />
          <button type="submit" aria-label="Szukaj"><span className="sg-pole-tekst">Szukaj</span><span className="sg-pole-ikona"><Strzalka rozmiar={20} /></span></button>
        </form>
        {/* Wejście do listingów pod polem (uwaga właściciela 2026-10-29: z nowej strony nie dało się przejść do katalogu). */}
        <nav className="sg-katalog" aria-label="Katalog produktów">
          <span className="sg-katalog-etykieta">Albo przeglądaj cały katalog</span>
          <div className="sg-katalog-kafle">
            {KATEGORIE.map((k) => (
              <Link key={k.key} to={k.route} className="sg-katalog-kafel">
                {IKONY_KATEGORII[k.key]}
                <span className="sg-katalog-nazwa">{k.katalog}<small>{k.licznik}</small></span>
                <svg className="sg-katalog-strzalka" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
              </Link>
            ))}
          </div>
        </nav>
      </div>
    </section>
  )
}

export default function StronaGlowna() {
  const [widok, setWidok] = useState('dom')
  const [graj, setGraj] = useState(false)
  const zegar = useRef(null)

  // Animacje startują razem dopiero po klasie .sg-graj; przy zmianie zakładki zaczynają od nowa.
  useEffect(() => {
    zegar.current = setTimeout(() => setGraj(true), 400)
    return () => clearTimeout(zegar.current)
  }, [])

  const wybierz = (nowy) => {
    if (nowy === widok) return
    setWidok(nowy)
    setGraj(false)
    clearTimeout(zegar.current)
    zegar.current = setTimeout(() => setGraj(true), 300)
  }

  const dom = widok === 'dom'
  return (
    <div className="sg">
      <main className="sg-glowna">
        <div className="sg-naglowek">
          <h1 className="sg-h1">Fotowoltaika bez zgadywania. <span>Dla domu i dla firm PV.</span></h1>
          <p className="sg-lead">Niezależnie, nie sprzedajemy instalacji. Ponad 2700 modeli modułów, falowników, magazynów i ładowarek, ocena ofert i narzędzia do sprzedaży.</p>
        </div>

        <div role="tablist" aria-label="Kim jesteś" className="sg-bramy">
          <button type="button" role="tab" id="sg-tab-dom" aria-controls="sg-panel" aria-selected={dom} className="sg-brama" onClick={() => wybierz('dom')}>
            <span className="sg-brama-ikona"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 11 12 4l9 7" /><path d="M5 10v10h14V10" /></svg></span>
            <span className="sg-brama-tekst"><strong>Buduję instalację dla domu</strong><span className="sg-brama-opis">Wykonawcy, sprzęt, ocena oferty. Za darmo.</span></span>
          </button>
          <button type="button" role="tab" id="sg-tab-firma" aria-controls="sg-panel" aria-selected={!dom} className="sg-brama" onClick={() => wybierz('firma')}>
            <span className="sg-brama-ikona"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg></span>
            <span className="sg-brama-tekst"><strong>Sprzedaję instalacje PV</strong><span className="sg-brama-opis">Projekt 3D, klienci, oferty, montaże i zlecenia.</span></span>
          </button>
        </div>

        <section id="sg-panel" role="tabpanel" aria-labelledby={dom ? 'sg-tab-dom' : 'sg-tab-firma'} className={`${dom ? '' : 'sg-firma'} ${graj ? 'sg-graj' : ''}`}>
          {dom ? <KartyDlaDomu /> : <DlaFirm />}
        </section>
      </main>

      <Wyszukiwarka />
    </div>
  )
}
